import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {
  AccountingDashboard,
  ChartOfAccounts,
  JournalEntries,
  FundManagement
} from '../components/Accounting';
import { ServiceProvider } from '../contexts/ServiceProvider';
import { useAuth } from '../../contexts/AuthContext';

export const AccountingRoutes: React.FC = () => {
  const { currentUser } = useAuth();
  
  return (
    <ServiceProvider>
      <Routes>
        <Route path="" element={<AccountingDashboard />} />
        <Route path="dashboard" element={<AccountingDashboard />} />
        <Route path="chart-of-accounts" element={<ChartOfAccounts />} />
        <Route path="journal-entries" element={<JournalEntries fiscalSponsorId={currentUser.fiscalSponsorId} />} />
        <Route path="fund-management" element={<FundManagement />} />
      </Routes>
    </ServiceProvider>
  );
};
